// extracted by mini-css-extract-plugin
export var active = "TabbedSection-module--active--8299e";
export var background = "TabbedSection-module--background--858f6";
export var button = "TabbedSection-module--button--141ec";
export var component = "TabbedSection-module--component--c8c23";
export var content = "TabbedSection-module--content--8e4a2";
export var fadePop = "TabbedSection-module--fade-pop--22fe1";
export var growHeightIn = "TabbedSection-module--grow-height-in--06b67";
export var inner = "TabbedSection-module--inner--ce3c9";